import React, { Component } from "react";
import LayoutWrapper from "../../../LayoutWrapper";
import "../module.scss";
import PhotoModal from "./PhotoModal";
import SessionSearch from "./SessionSearch";

export class AssessmentsPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("AssessmentsPage");
    this.state = {
      data: [],
      form: [],
      currentAssessment: {},
      rowcount: 0,
      errors: {},
      breadcrum: "",
      tablinks: [],
      assessment_answers: [],
      selectedQuestion: null,
    };
    this.errorsMessages = {};
    this.photoModalRef = React.createRef();
  }

  get errors() {
    return Object.entries(this.errorsMessages)
      .filter(([key, val]) => val)
      .map(([key, val]) => key);
  }

  get isValid() {
    let data = this.formData;
    let keys = Object.keys(data);
    // let { fields = [] } = this.state.form || {};
    let fields = this.state.form || [];
    return keys.reduce((flag, key) => {
      let field = fields.find((o) => o.label == key || o.name == key) || {};
      let constraints = field.fieldConstraint
        .filter((v) => v)
        .map((v) => _enum.CONSTRAINTS_LMS_MAP[v]);
      let value = data[key];
      let valid = constraints.reduce(
        (flag, v) =>
          flag &&
          ((typeof v == "string" && value.match(new RegExp(v))) ||
            (typeof v == "function" &&
              v(field.fieldType == "date" ? value.date() : value))),
        true
      );
      if (!constraints.includes("mandatory") && !value) {
        valid = true;
      }
      if (!valid) {
        this.errorsMessages[key] = true;
      } else {
        this.errorsMessages[key] = false;
      }
      return flag && !!valid;
    }, true);
  }

  get formData() {
    return this.refs.form.form.current.getData();
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    try {
      const { data } = await this.props.api.apiGetAssessments({
        session_id: this.props.urlparams.sessionId,
      });

      const assessmentData = [];

      for (const item of data) {
        const assessmentResponse = await this.props.api.apiGetAssessmentById({
          assessment_id: item.assessment_id,
        });
        item.assessment_questions =
          assessmentResponse.data?.assessment_questions;
        assessmentData.push(item);
      }

      this.setState({
        form: assessmentData,
        data: assessmentData,
        currentAssessment: assessmentData[0],
      });
    } catch (error) {
      // Handle errors here
      console.error("Error fetching data:", error);
    }
  }

  handleClose(e, values) {
    e.preventDefault();
    e.stopPropagation();
    this.props.navigate(
      `/mycontent/sessions?packageId=${this.props.urlparams?.packageId}&packageName=${this.props.urlparams?.packageName}`
    );
  }

  getBackLink() {
    return `/mycontent/sessions?packageId=${this.props.urlparams?.packageId}&packageName=${this.props.urlparams?.packageName}`;
  }

  onInputChange(field, event, ...args) {
    let value = "";
    if (event?.nativeEvent instanceof InputEvent) {
      value = event.target.value;
    } else if (event instanceof String) {
      value = event;
    } else if (event instanceof Number) {
      value = "" + event;
    }
  }

  // onFieldFocus(field) {
  //   console.log(field);
  // }

  isCheckboxOrRadio(type) {
    return ["checkbox", "radio"].includes(type);
  }

  linkGeneration(attach_file) {
    let authToken = window.store.getState().root.auth;
    return (
      app.api
        .request(app.apis().fileDownloader)
        .urltransform({ attachmentId: attach_file }).url +
      "?auth=" +
      authToken
    );
  }
  getTitle() {
    return "My Content";
  }
  getBreadCums() {
    return `My Content / ${this.props.urlparams?.packageName} / ${this.props.urlparams?.sessionName} Assessment`;
  }
  handleCurrentAssessment(item) {
    this.setState({
      currentAssessment: item,
    });
    console.log(this.state.currentAssessment);
  }
  submitForm(e, data, form, field) {
    // let assessment_answers = Object.entries(form.getData()).map(
    //   ([key, value]) => ({
    //     question_id: key,
    //     customer_answer: value,
    //   })
    // );

    // let payload = {
    //   ...{
    //     session_id: this.props.urlparams.session_id,
    //     assessment_id: this.state.currentAssessment.assessment_id,
    //   },
    //   ...{ assessment_answers: assessment_answers },
    // };

    // console.log("payload: ", payload);
    // success("Assessment Submitted Successfully");

    // if (!this.isValid) {
    //   alert("Please fill valid values in " + this.errors.join(","));
    //   return;
    // }
    // let parsedPayload = parseInput(data);

    let assessment_answers = Object.entries(form.getData()).map(
      ([key, value]) => ({
        question_id: key,
        customer_answer: value,
      })
    );

    let storedUser = window.store.getState().root.user;
    let payload = {
      ...{
        package_id: this.props.urlparams.packageId,
        session_id: this.props.urlparams.sessionId,
        assessment_id: this.state.currentAssessment.assessment_id,
      },
      ...{ assessment_answers: assessment_answers },
    };

    console.log({ payload });

    this.props.api.apiAddCustomerAssessment(payload).then((response) => {
      success("Your Assessment Submitted Successfully");
      this.props.navigate(
        `/mycontent/sessions?packageId=${this.props.urlparams?.packageId}&packageName=${this.props.urlparams?.packageName}`
      );
    });
  }
  render() {
    let { data = [], form = [], breadcrum, currentAssessment } = this.state;
    // let { tablinks } = this;
    console.log("tablinks----", form);
    console.log("This is currentData ", this.state.data);
    console.log("this is currentAssessment", this.state.currentAssessment);
    return (
      <LayoutWrapper
        title={this.getTitle()}
        back={this.getBreadCums()}
        backlink={this.getBackLink()}
      >
        {/* <SessionSearch onSearch={(...arg) => this.onSearch(...arg)} /> */}
        {form?.map((item, i) => {
          return (
            <button
              key={i}
              onClick={() => {
                this.handleCurrentAssessment(item);
              }}
              className={`btn rounded-full border mx-1 min-w-[150px] m-clip ${
                currentAssessment.assessment_id === item.assessment_id
                  ? "tab-active"
                  : ""
              }`}
            >
              {item.assessment_name}
            </button>
          );
        })}

        <div className="d-flex align-items-center justify-content-center form_outer">
          {currentAssessment ? (
            <AppForm
              className="m-auto p-2 w-full custom_form"
              onSubmit={(...args) => this.submitForm(...args)}
              ref="form"
            >
              <div key={currentAssessment.assessment_id} className="grow">
                {currentAssessment?.assessment_questions?.map((ques, j) => (
                  <div>
                    {this.isCheckboxOrRadio(ques.q_type) && (
                      <div className="list-group option_box">
                        {ques.attach_file_type ? (
                          <AppInput
                            type="link"
                            ref={this.photoModalRef}
                            data-bs-toggle="modal"
                            data-bs-target="#photo_modal"
                            id={j}
                            label={`${j + 1}. ${ques.q_label}`}
                            linkLabel={`${
                              ques.attach_file_type == "VIDEO"
                                ? "Play Video"
                                : "View Image"
                            }`}
                            value={ques}
                            onLinkClick={(props) => {
                              if (!this.state.selectedQuestion) {
                                this.setState({
                                  selectedQuestion: {
                                    ...props,
                                    src:
                                      props.attach_file_type == "IMAGE"
                                        ? this.linkGeneration(props.attach_file)
                                        : "",
                                  },
                                });
                                this.photoModalRef.current.click();
                              }
                            }}
                          />
                        ) : (
                          <label className="col-form-label">
                            {j + 1}. {ques.q_label}
                          </label>
                        )}
                        {ques.q_options.map((option, k) => (
                          <AppInput
                            key={"option_" + "-" + k}
                            type={ques.q_type}
                            className="list-group-item"
                            name={ques.question_id}
                            value={option}
                            disabled={
                              localStorage.getItem("currentAdminRole") ==
                              "SCHOOL_COORDINATOR"
                            }
                          >
                            {ques.q_type === "checkbox" && option}
                          </AppInput>
                        ))}
                      </div>
                    )}
                    {!this.isCheckboxOrRadio(ques.q_type) && (
                      <div>
                        <AppInput
                          title={ques.q_label}
                          type={ques.q_type}
                          name={ques.question_id}
                          label={`${j + 1}. ${ques.q_label}`}
                          className="list-group option_box"
                          disabled={
                            localStorage.getItem("currentAdminRole") ==
                            "SCHOOL_COORDINATOR"
                          }
                          {...(ques.q_type == "date"
                            ? {
                                disabledDates: (date) =>
                                  this.handelDisabledDates(date, ques),
                              }
                            : {})}
                          {...(ques.q_type == "file"
                            ? {
                                fileType: "data_collection_form",
                              }
                            : {})}
                          options={
                            ques.q_options
                              ? ques.q_options
                                  // .split(",")
                                  .options("", "", (v) => v)
                              : []
                          }
                          // required={field.fieldConstraint.includes("mandatory")}
                          // onChange={(...args) =>
                          //   this.onInputChange(ques, ...args)
                          // }
                        ></AppInput>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <PhotoModal
                ref={this.photoModalRef}
                id="photo_modal"
                title=""
                data={this.state.selectedQuestion}
                className="photo_modal"
                onClose={() => {
                  this.setState({
                    selectedQuestion: null,
                  });
                }}
              ></PhotoModal>
              <div className="mt-4 flex justify-content-end">
                <button className="btn add-btn col col-md-1 ml-auto">
                  Submit
                </button>
                <button
                  type="button"
                  onClick={(...args) => this.handleClose(...args)}
                  className="btn btn_primary col col-md-1 ml-auto grey ms-2 me-2"
                >
                  Cancel
                </button>
              </div>
            </AppForm>
          ) : (
            <div className="empty_layout "></div>
          )}
        </div>
        {/* {form.length == 0 && <div className="empty_layout "></div>} */}
      </LayoutWrapper>
    );
  }
}

export default connect(AssessmentsPage);
